import React from 'react';
import About from '../components/About/About';
import { FaHome } from 'react-icons/fa';
import Projects from '../components/Projects/Projects';
import Skills from '../components/Skills/Skills';
import Contact from '../components/Contact/Contact';

const Home = () => {
  return (
    <div
      id="home"
      className={` bg-slate-900 min-h-screen flex flex-col lg:ml-[5rem] lg:px-0 px-6 mt-14`}
    >
      <FaHome className="fixed text-teal-400 font-outfit opacity-5 text-[13rem]  bottom-0 " />
      <About />

      <Skills />
      <Projects />
      <Contact />
    </div>
  );
};

export default Home;
